import { render, staticRenderFns } from "./ProjectRestaurantBooking.vue?vue&type=template&id=7ff47610"
import script from "./ProjectRestaurantBooking.vue?vue&type=script&lang=ts"
export * from "./ProjectRestaurantBooking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports